export default function sliceListIntoChunks(arr, chunkSize) {
  try {
    if (chunkSize > 0) {
      const res = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
      }
      return res;
    } else {
      return [];
    }
  } catch (e) {
    console.log(e);
    return [];
  }
}
